import request from '../utils'

const datasetApi = {
    datasetList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/dataset`)
        const res = await req;
        return res.body;
    }, 
    datasetDetail: async (modelingId, dataset) => {
        const req = request.get(`/api/modeling/${modelingId}/dataset/${dataset}`)
        const res = await req;
        return res.body;
    },
    datasetSections: async (modelingId, dataset) => {
        const req = request.get(`/api/modeling/${modelingId}/dataset/${dataset}/sections`)
        const res = await req;
        return res.body;
    },
    datasetUpdate: async (modelingId, dataset) => {
        const req = request.put(`/api/modeling/${modelingId}/dataset/${dataset.id}`).send(dataset);
        const res = await req;
        return res.body;
    },
    datasetUpload: async (modelingId, datasetId, files) => {
        const req = request.postMultipart(`/api/modeling/${modelingId}/dataset/upload/${datasetId}`);
        for (const file of files) {
            req.attach("files", file);
        }
        const res = await req;
        return res.body;
    },
    datasetXlsxUpload: async (modelingId, datasetId, files) => {
        const req = request.postMultipart(`/api/modeling/${modelingId}/dataset/upload/${datasetId}/xlsx`);
        for (const file of files) {
            req.attach("files", file);
        }
        const res = await req;
        return res.body;
    },
    datasetZipDownload: (modelingId, datasetId) => {
        const req = request.get(`/api/modeling/${modelingId}/dataset/download/${datasetId}/datasetzip`);
        return req;
    },
    datasetCreate: async (modelingId, dataset) => {
        const req = request.post(`/api/modeling/${modelingId}/dataset`).send(dataset);
        const res = await req;
        return res.body;
    },
    datasetDelete: async (modelingId, datasetId) => {
        const req = request.delete(`/api/modeling/${modelingId}/dataset/${datasetId}`);
        await req;
    }
};

export default datasetApi